import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  postal_code: z
    .string()
    .min(1, t('pages.accountdetail.components.tabs.localizationtab.schema.required'))
    .refine(cep => {
      const cleanedCep = cep.replace(/\D/g, '');

      return cleanedCep.length === 8;
    }, t('pages.accountdetail.components.tabs.localizationtab.schema.invalid_postal_code')),
  line1: z.string().min(1, t('pages.accountdetail.components.tabs.localizationtab.schema.required')),
  line2: z.string().min(1, t('pages.accountdetail.components.tabs.localizationtab.schema.required')),
  line3: z.string().min(1, t('pages.accountdetail.components.tabs.localizationtab.schema.required')),
  neighborhood: z.string().min(1, t('pages.accountdetail.components.tabs.localizationtab.schema.required')),
  city: z.string().min(1, t('pages.accountdetail.components.tabs.localizationtab.schema.required')),
  state: z.string().min(1, t('pages.accountdetail.components.tabs.localizationtab.schema.required')),
  country: z.string().min(1, t('pages.accountdetail.components.tabs.localizationtab.schema.required')),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
